import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { chinaContract } from "../../utils/contractHelpers";
import Environment from "../../utils/Environment";

const usePurchaseLink = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const UsdtAdress = Environment.link;
  const tokenAddress = Environment.presaleContract;
  const contract = chinaContract(tokenAddress, web3);

  const purchaseLink = useCallback(
    async (amount, postApiRes, id, balance, min, stakeIndex, index, insurancePer) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");

      /* ------------------ Amount calculation ------------------ */
      let nd;
      if (index) {
        const value = parseFloat(amount) + parseFloat(amount) * insurancePer;
        const valueAmount = Math.round(parseFloat(value.toFixed(6)) * 1e12) / 1e12;
        nd = web3.utils.toWei(valueAmount.toString(), "ether");
      } else {
        const valueAmount = Math.round(parseFloat(parseFloat(amount).toFixed(6)) * 1e12) / 1e12;
        nd = web3.utils.toWei(valueAmount.toString(), "ether");
      }

      /* ------------------ Min value ------------------ */
      let minValue = Math.round(parseFloat((min * 0.99).toFixed(6)) * 1e12) / 1e12;
      minValue = web3.utils.toWei(minValue.toString(), "ether");

      console.log("purchaseLink params:", nd, minValue, postApiRes.code, id);

      /* ------------------ Send TX (EVENT BASED) ------------------ */
      try {
        return new Promise(async (resolve, reject) => {
          let gas, gasPrice;

          try {
            gasPrice = await web3.eth.getGasPrice();
            gasPrice = parseInt(gasPrice) + 3000000000;

            gas = await contract.methods
              .purchaseTokenWithToken(
                UsdtAdress,
                postApiRes?.normalizationFactor,
                postApiRes?.normalizationFactorNft,
                postApiRes?.price,
                nd,
                minValue,
                stakeIndex,
                postApiRes?.agentsAddresses,
                postApiRes?.agentsPercentages,
                postApiRes.code,
                id,
                postApiRes.deadline,
                postApiRes?.v,
                postApiRes?.r,
                postApiRes?.s
              )
              .estimateGas({ from: account, gasPrice });
          } catch (err) {
            return reject(err);
          }

          contract.methods
            .purchaseTokenWithToken(
              UsdtAdress,
              postApiRes?.normalizationFactor,
              postApiRes?.normalizationFactorNft,
              postApiRes?.price,
              nd,
              minValue,
              stakeIndex,
              postApiRes?.agentsAddresses,
              postApiRes?.agentsPercentages,
              postApiRes.code,
              id,
              postApiRes.deadline,
              postApiRes?.v,
              postApiRes?.r,
              postApiRes?.s
            )
            .send({ from: account, gas, gasPrice })

            /* optional: log tx hash */
            .on("transactionHash", (hash) => {
              console.log("purchaseLink tx hash:", hash);
            })

            /* ✅ RESOLVE ONLY ON RECEIPT */
            .on("receipt", (receipt) => {
              console.log("purchaseLink confirmed:", receipt);
              resolve({ transactionHash: receipt?.transactionHash });
            })

            /* ❌ ERROR */
            .on("error", (error) => {
              console.error("purchaseLink error:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3]
  );

  return { purchaseLink };
};

export default usePurchaseLink;

// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import { chinaContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";
// import { toast } from "react-toastify";

// const PurchaseLink = () => {
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const UsdtAdress = Environment.link;
//   const priceUsdt = 10000;
//   const tokenAddress = Environment.presaleContract;
//   const contract = chinaContract(tokenAddress, web3);
//   const purchaseLink = useCallback(
//     async (
//       amount,
//       postApiRes,
//       id,
//       balance,
//       min,
//       stakeIndex,
//       index,
//       insurancePer
//     ) => {
//       console.log(
//         amount,
//         postApiRes,
//         id,
//         balance,
//         min,
//         stakeIndex,
//         index,
//         insurancePer,
//         "amount, postApiRes,id,balance,min,stakeIndex"
//       );
//       let nd = 0;
//       if (index) {
//         let percecnt = parseFloat(amount) * insurancePer;
//         let value = parseFloat(amount) + percecnt;
//         let aaamount = parseFloat(value).toFixed(6);
//         let amount1 = Math.round(aaamount * 1e12) / 1e12;
//         nd = web3.utils.toWei(amount1.toString(), "ether");
//       } else {
//         let aaamount = parseFloat(amount).toFixed(6);
//         let amount1 = Math.round(aaamount * 1e12) / 1e12;
//         nd = web3.utils.toWei(amount1.toString(), "ether");
//       }
//       console.log(nd, "nd");

//       let minvalue = min * 0.99;
//       minvalue = parseFloat(minvalue).toFixed(6);
//       minvalue = Math.round(minvalue * 1e12) / 1e12;
//       console.log(minvalue, "minvalue");
//       minvalue = web3.utils.toWei(minvalue.toString(), "ether");
//       console.log(minvalue, "minvalue");
//       // console.log(postApiRes?.factorNormalization,UsdtAdress,priceUsdt.toString(),minvalue,postApiRes.code,id,postApiRes.deadline, postApiRes?.v, postApiRes?.r, postApiRes?.s,' nd,postApiRes.code,id,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s');
//       //     let tuple = {
//       //       postApiRes.code:postApiRes.postApiRes.code,
//       //       GodAgentPercentage:postApiRes.gotAgentPercentage,
//       //       MegaAgentPercentage:postApiRes.megaAgentPercentage,
//       //       SuperAgentPercentage:postApiRes.superAgentPercentage,
//       //       AgentPercentage:postApiRes.agentPercentage,
//       //       GodAgentAddress:postApiRes.gotAgentAddress,
//       //       MegaAgentAddress:postApiRes.megaAgentAddress,
//       //       SuperAgentAddress:postApiRes.superAgentAddress,
//       //       AgentAddress:postApiRes.agentAddress,
//       // };
//       let gas;
//       try {
//         let gasPrice = await web3.eth.getGasPrice();
//         gasPrice = parseInt(gasPrice) + 3000000000;
//         gas = await contract.methods
//           .purchaseTokenWithToken(
//             UsdtAdress,
//             postApiRes?.normalizationFactor,
//             postApiRes?.normalizationFactorNft,
//             postApiRes?.price,
//             nd,
//             minvalue,
//             stakeIndex,
//             postApiRes?.agentsAddresses,
//             postApiRes?.agentsPercentages,
//             // index,
//             postApiRes.code,
//             id,
//             postApiRes.deadline,
//             postApiRes?.v,
//             postApiRes?.r,
//             postApiRes?.s
//           )
//           .estimateGas({
//             from: account,
//             gasPrice,
//           });
//         const details = await contract.methods
//           .purchaseTokenWithToken(
//             UsdtAdress,
//             postApiRes?.normalizationFactor,
//             postApiRes?.normalizationFactorNft,
//             postApiRes?.price,
//             nd,
//             minvalue,
//             stakeIndex,
//             postApiRes?.agentsAddresses,
//             postApiRes?.agentsPercentages,
//             // index,
//             postApiRes.code,
//             id,
//             postApiRes.deadline,
//             postApiRes?.v,
//             postApiRes?.r,
//             postApiRes?.s
//           )
//           .send({
//             from: account,
//             gas: gas,
//             gasPrice,
//           });
//         return details;
//       } catch (error) {
//         // let gasPrice1=await web3.eth.getGasPrice()
//         // let gasPrice = parseInt(gasPrice1) + 3000000000
//         // gas=gas*gasPrice
//         // let nd = web3.utils.fromWei(gas.toString(), "ether");
//         // console.log(gas,nd,balance );
//         // if(nd>balance){
//         //    toast.error("Insufficient ETH for Transaction")
//         // }else{
//         throw error;
//         // }
//       }
//     },
//     [contract, account, web3]
//   );
//   return { purchaseLink: purchaseLink };
// };
// export default PurchaseLink;
